var _line, _line2, _line3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlignLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "ql-stroke",
    x1: 3,
    x2: 15,
    y1: 9,
    y2: 9
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "ql-stroke",
    x1: 3,
    x2: 13,
    y1: 14,
    y2: 14
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "ql-stroke",
    x1: 3,
    x2: 9,
    y1: 4,
    y2: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlignLeft);
export default __webpack_public_path__ + "static/media/align-left.0f8ad7994ca19d6495042555af243eef.svg";
export { ForwardRef as ReactComponent };